import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const ElizaService = {
  getElizaDetails: () =>
    requests(SERVICE_NAME.AUTOMATION_ELIZA_API).get("report/billing"),
};

export default ElizaService;
